module.exports = __webpack_public_path__ + "static/media/ploni-demibold-aaa.61ba93b8.woff";